
import { PRODUCT_DETAIL_FIELDS } from '../constant/page-constant';


export const sortBatchesByExpiry = (inventory = []) => {
  return [...inventory].sort((a, b) => {
    const dateA = new Date(a[PRODUCT_DETAIL_FIELDS.EXPIRY_DATE])
    const dateB = new Date(b[PRODUCT_DETAIL_FIELDS.EXPIRY_DATE])
    return dateA - dateB
  })
}


export const calculateFEFOBatches = (inventory = [], requiredQuantity = 0) => {
  if (!inventory.length || !requiredQuantity) return []

  const sortedBatches = sortBatchesByExpiry(inventory)
  const allocatedBatches = []
  let remainingQuantity = parseInt(requiredQuantity)

  for (const batch of sortedBatches) {
    if (remainingQuantity <= 0) break

    const availableStock = parseInt(batch[PRODUCT_DETAIL_FIELDS.STOCK])
    const allocatedQty = Math.min(remainingQuantity, availableStock)

    allocatedBatches.push({
      ...batch,
      allocatedQuantity: allocatedQty,
    })

    remainingQuantity -= allocatedQty
  }

  return allocatedBatches
}

// ✅ Sum all batch stock
export const getTotalAvailableStock = (inventory = []) => {
  return inventory.reduce(
    (sum, batch) => sum + parseInt(batch[PRODUCT_DETAIL_FIELDS.STOCK] || 0),
    0
  )
}
